import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=29cce41a&"
import script from "./BrandsView.vue?vue&type=script&lang=js&"
export * from "./BrandsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports